import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About, { StatsBar } from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Vision from './components/Vision';
import Cursor from './components/Cursor';
import { logVisit } from './lib/supabase';
import './index.css';

export default function App() {
  useEffect(() => {
    // Log visit silently
    logVisit().catch(() => { });

    // Reveal on scroll for all .reveal elements
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Cursor />
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <About />
        <Vision />
        <Skills />
        <Projects />
        <Experience />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
